
import { Award, Clock, Shield, Headphones } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const AboutSection = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: Award,
      title: t('about.expert.title'),
      description: t('about.expert.description')
    },
    {
      icon: Clock,
      title: t('about.flexible.title'),
      description: t('about.flexible.description')
    },
    {
      icon: Shield,
      title: t('about.certificate.title'),
      description: t('about.certificate.description')
    },
    {
      icon: Headphones,
      title: t('about.support.title'),
      description: t('about.support.description')
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center gap-12 mb-16">
          <div className="lg:w-1/2 w-full">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl group">
              <div className="w-full h-[480px]">
                <img
                  src="https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/85645b72d0cb95a9920fc5c6b25ea3dd.jpeg"
                  alt="IQ CERT ISO Sertifikaları - ISO 9001, ISO 14001, HACCP, SCC belgelendirme sertifikaları"
                  title="IQ CERT Uluslararası Belgelendirme Sertifikaları"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-6">
                <p className="text-white font-semibold text-lg">{t('about.certificates.badge')}</p>
                <p className="text-white/80 text-sm mt-1">{t('about.certificates.badgeDesc')}</p>
              </div>
            </div>
          </div>

          <div className="lg:w-1/2 w-full">
            <span className="inline-block px-4 py-1.5 bg-teal-50 text-teal-700 rounded-full text-sm font-medium mb-4">
              {t('about.tagline')}
            </span>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              {t('about.title')}
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              {t('about.subtitle')}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {features.map((feature, index) => {
                const IconComponent = feature.icon;
                return (
                  <div key={index} className="flex items-start gap-4 group cursor-pointer">
                    <div className="w-12 h-12 min-w-[48px] bg-teal-100 rounded-lg flex items-center justify-center group-hover:bg-teal-600 transition-colors">
                      <IconComponent className="w-6 h-6 text-teal-600 group-hover:text-white transition-colors" />
                    </div>
                    <div>
                      <h3 className="text-base font-semibold text-gray-900 mb-1">
                        {feature.title}
                      </h3>
                      <p className="text-sm text-gray-600 leading-relaxed">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
